var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-container",staticStyle:{"line-height":"2"}},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_vm._v(" 测量范围 ")]),_c('el-col',{attrs:{"span":12}},[_vm._v(" 不确定度/准确度等级/最大允许误差 ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }